export function toggleDropdown ({uid, name}) {
  const body = {
    'App Name': name,
    'App ID': uid
  }
  const eventName = 'Connect Menu'
  clevertap.event.push(eventName, body)
  mixpanel.track(eventName, body)
}

export function clickEdit ({uid, name}) {
  const body = {
    'App Name': name,
    'App ID': uid
  }
  const eventName = 'Connect Menu Edit'
  clevertap.event.push(eventName, body)
  mixpanel.track(eventName, body)
}

export function clickDelete ({uid, name}) {
  const body = {
    'App Name': name,
    'App ID': uid
  }
  const eventName = 'Connect Menu Delete'
  clevertap.event.push(eventName, body)
  mixpanel.track(eventName, body)
}



// WEBPACK FOOTER //
// app/javascript/components/mixpanel/frags/tripleDotDropdown.js